import { HttpStatusCode } from '@visiba/http';

export interface ProblemDetails<T extends string> {
	type: T;
	title: string;
	detail: string;
	status: HttpStatusCode;
	validationProblems: [];
}

/**
 * ## @visiba/http
 *
 * Will loosely assert that an unknown value is actually shaped as an ProblemDetails so it
 * may be casted as such.
 */
export function isProblemDetails<T extends string>(value: unknown): value is ProblemDetails<T> {
	if (typeof value !== 'object' || value === null) {
		return false;
	}

	// We need to sync with the backend guys which one we should
	// discriminate on.
	if (!('type' in value) || !('traceId' in value)) {
		return false;
	}
	// if ('type' in value && 'detail' in value) {
	// 	return false;
	// }

	return true;
}

export function isSpecificProblemDetails<T extends string>(type: T, value: unknown): value is ProblemDetails<T> {
	if (!isProblemDetails(value)) return false;

	return value.type === type;
}

export function problemDetailType(variant: string): string {
	if (variant[0] === '/') {
		variant = variant.slice(1);
	}

	return 'https://idp.problems.visiba.dev/' + variant;
}
